import React from 'react'
import { useEffect } from 'react';

import {useSubscribe} from '../useSubscribe'
import Axios from 'axios'
import Navbar from '../components/navbar'

export default function Profile({loginDetail, setLoginDetail, responseStatus}) {
    Axios.defaults.withCredentials = true

    const { getSubscription, setSubscription } = useSubscribe({publicKey: "BMul4r89zMDkkdEjH8JEQYZmvOWbqjgMATBqLO_vPGOj6T_qkOWW3FIhiYgNsmGealGb_eSePF6_HcPZu1-cl-c"});

    const onSubmitSubscribe = async (e) => {
        try {
            if(loginDetail.notifications){
                await setSubscription(false)
                await Axios.post('/api/unsubscribe', {});
                setLoginDetail({...loginDetail, notifications: false})
            } else {
                await setSubscription(true)
                await Axios.post('/api/subscribe', {
                    subscription: await getSubscription(),
                });
                setLoginDetail({...loginDetail, notifications: true})
            }
        } catch (e) {
            console.warn(e);
        }
    };

    const onNotificationModeSubscribe = async (e) => {
        try {
            let mode = "unique"
            if (loginDetail.notification_mode == "unique") mode = "all"
            let res = await Axios.post(`/api/subscribe/${mode}`, {});
            setLoginDetail({...loginDetail, notification_mode: res.data.mode})
        } catch (e) {
            console.warn(e);
        }
    };

    if (responseStatus && loginDetail !== "") {
        return (
            <div>
                <Navbar loginDetail={loginDetail} />
                <br></br>
                <br></br>
                <br></br>
                <p>username: {loginDetail.username}</p>
                <p>referral: {loginDetail.referral}</p>
                <p>pushid: {loginDetail.pushid}</p>

                <p>notifications: {loginDetail.notifications.toString()}
                {loginDetail.id && <button onClick={onSubmitSubscribe}>{loginDetail.notifications ? "Unsubscribe" : "Subscribe"}</button>}</p>

                <p>notification_mode: {loginDetail.notification_mode}<button onClick={onNotificationModeSubscribe}>Change</button></p>

                <br/>
                <p><b>GET</b> https://{window.location.hostname}/api/send?pushid={loginDetail.pushid}&title=Web&message=HelloWorld</p>
                <br/>
                <p><b>POST</b> https://{window.location.hostname}/api/send</p>
                <b>x-www-form-urlencoded:</b>
                <p></p>
                <p>pushid: {loginDetail.pushid}</p>
                <p>title: Web</p>
                <p>message: HelloWorld</p>
                <br/>
            </div>
        )
    } else if (responseStatus && loginDetail === "") {
        window.location.href = "/authenticate"
    }
    return (
        <div>

        </div>
    )
}